import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isEmpty, isEqual } from 'lodash'
import { toggleNoti, toggleError } from 'config/slice/message'
import {
    TYPE_PASSWORD,
    TYPE_PASSWORD_VERIFY
} from 'config/const/type'
import {
    KEY_BTN_RESETPWD,
    KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL,
    KEY_ERROR_PASSWORD_NOT_FILL,
    KEY_ERROR_PWD_NOT_SAME,
    KEY_ERROR_RESET_FAILED,
    KEY_NOTI_RESET_SUCC,
    KEY_TEXT_IPT_PWD,
    KEY_TEXT_IPT_PWD_CONFIRM,
    KEY_TEXT_RESETPWD_MODAL_TITLE,
    MODULE_RESET_PWD,
} from 'config/const/locale'
import { useResetPwdMutation } from 'config/api/waV1_user'
import { useLocation, useSearchParams } from 'react-router-dom'
import { STATUS_API_RESET } from 'config/const/global'


// TODO -- get token and email from url
export default function ResetPWD() {

    const [iptValue, setIptValue] = useState({
        [TYPE_PASSWORD]: '',
        [TYPE_PASSWORD_VERIFY]: ''
    }) // inputs' value
    const [sent, setSent] = useState(false)
    const dispatch = useDispatch() // redux method manipulating the state
    const { t } = useTranslation(MODULE_RESET_PWD) // i18n hook, i18n.changeLanguage('en') method to change language
    const [resetPwdFn] = useResetPwdMutation()
    const location = useLocation()
    const [searchParam, setSearchParam] = useSearchParams()



    /**
     * handle inputs relating to login
     * @param {String} type input's type and key
     */
    const iptHandler = (type) => (e) => setIptValue(prev => ({ ...prev, [type]: e.target.value }))

    // login btn handler, data checking and msg noticing
    const forgetPwdHandler = () => {
        console.log(iptValue)
        if (isEmpty(iptValue[TYPE_PASSWORD])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PASSWORD_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_PASSWORD_VERIFY])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL)
            }))
            return
        }
        if (!isEqual(iptValue[TYPE_PASSWORD], iptValue[TYPE_PASSWORD_VERIFY])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PWD_NOT_SAME)
            }))
            return
        }

        setSent(true)
        window.forgetTimer = setTimeout(() => {
            setSent(false)
        }, 1000 * 10);
        resetPwdFn({
            email: searchParam.get('email'),
            "password": iptValue[TYPE_PASSWORD],
            "password_confirmation": iptValue[TYPE_PASSWORD_VERIFY],
            "token": searchParam.get('token')
        })
            .then(res => {
                if (res.data?.data?.status == STATUS_API_RESET) {
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_RESET_SUCC)
                    }))
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_RESET_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_RESET_FAILED)
                }))
            })
    }

    useEffect(() => {
        if (!sent) {
            clearTimeout(window?.forgetTimer)
        }
    }, [sent])

    return (
        <div className='wa-fullscreen wa-bg-login'>

            <div className="login-box position-fixed start-50 top-50 translate-middle">
                <div className="card wa-light-blue wa-rounded-2rem overflow-hidden">
                    <div className="card-header">
                        <div className="link-dark text-center link-offset-2 link-opacity-100 link-opacity-50-hover text-white wa-light-blue">
                            <h1 className='fs-3 p-3'>
                                {t(KEY_TEXT_RESETPWD_MODAL_TITLE)}
                            </h1>
                        </div>
                    </div>
                    <div className="card-body login-card-body">
                        <form>
                            <div className="input-group mb-1">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="resetpwd" type="password" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PASSWORD)} />
                                    <label htmlFor="loginEmail" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_PWD)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            <div className="input-group my-4">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="resetrepwd" type="password" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PASSWORD_VERIFY)} />
                                    <label htmlFor="loginEmail" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_PWD_CONFIRM)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            {/* <!--begin::Row--> */}
                            <div className="row my-4">
                                <div className="col-12">
                                    <div className="d-grid gap-2" onClick={sent ? () => { } : forgetPwdHandler}>
                                        <a className={sent ? "btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill wa-btn-disable" : "btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill"}>{t(KEY_BTN_RESETPWD)}</a>
                                    </div>
                                </div>
                                {/* <!-- /.col --> */}
                            </div>
                            {/* <!--end::Row--> */}
                        </form>
                    </div>
                    {/* <!-- /.login-card-body --> */}
                </div>
            </div>
        </div>
    )
}
